<template>
   <!-- 头部导航-->
   <div>
     <div class="navbar" :class="isTransparent ? 'transparent' : ''">
      <router-link to="/"><img src="../../assets/images/jinsehotLogo.svg"/></router-link>
      <p>
        <span class=" navbar-bar" :class="isHome ? 'navbar-border-line' : ''" ><router-link class="navbar-router"  to="/">首页</router-link></span>
        <span class="navbar-bar checkin" @click="application">入驻</span>
        <!-- <span class="navbar-bar">简体中文</span> -->
      </p>
    </div>
      <application-access v-on:listen-is-show="showChild" :is-show="isShow" :type="type"></application-access>
   </div>
</template>

<script type="text/javascript">
/**
 * 头部导航
 *
 * @requires App.vue
 * @author liguojie
 */
import ApplicationAccess from '@/components/ApplicationAccess'
export default {
  name: 'CoinDogHeader',
  components: {
    ApplicationAccess
  },
  data () {
    return {
      type: 'checkin', // 入驻类型申请
      isHome: true,
      isShow: false, // 显示接入输入模态框
      isTransparent: true,
      chosed: 0, // 选中的tab,默认第一个
      navList: [ // 导航数据
        {
          name: '首页',
          router: '/'
        },
        {
          name: '入住',
          router: '/'
        },
        {
          name: '简体中文',
          router: '/'
        }
      ]
    }
  },
  methods: {
    navbarChange (i) { // 切换头部导航,i下标
      // this.chosed = i
    },
    application () { // 申请接入
      this.isShow = true
    },
    showChild (data) {
      this.isShow = data
    }
  },
  watch: {
    $route (to, from) {
      this.isHome = this.$route.path === '/'
    }
  },
  mounted () { // 滚动顶部导航颜色变化
    window.addEventListener('scroll', () => {
      let hNum = document.documentElement.scrollTop || document.body.scrollTop
      this.isTransparent = !(hNum > 20)
    })
  }
}
</script>

<style lang="scss" scoped>
.navbar{
  border-bottom:1px solid #21212A;
  min-width: 1200px;
  position: fixed;
  top: 0;
  box-sizing: border-box;
  background: #21212A;
  width: 100%;
  height: 76px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 135px;
  z-index: 99;
  box-shadow: 0 5px 10px rgba(0,9,128,.035), 0 7px 18px rgba(0,9,128,.05);
  transition: box-shadow .35s ease-out,background-color .35s ease-out;
  .navbar-router{
    text-decoration: none;
    font-size:14px;
    font-family:PingFangTC-Light;
    font-weight:300;
    color:rgba(255,255,255,1);
    height: 76px;
    line-height: 76px;
    display: inline-block;
    box-sizing: border-box;
  }
  .navbar-bar{
    cursor: pointer;
    font-size:14px;
    font-family:PingFangTC-Light;
    font-weight:300;
    color:rgba(255,255,255,1);
    height: 76px;
    line-height: 76px;
    display: inline-block;
    padding: 0 26px;
    box-sizing: border-box;
  }
  .navbar-border-line{
    border-bottom: 3px solid rgba(255,255,255,1);
  }
  .checkin:hover{
    border-bottom: 3px solid rgba(255,255,255,1);
  }
}
.transparent {
    box-shadow: none;
    background-color: transparent;
    border-bottom: 1px solid rgba(255,255,255,0.2);
  }
</style>
